import { Box, Button, Divider, List, Stack, Typography } from "@mui/material"
import { Repeat } from "lib/@components/repeat"
import { If } from "lib/@components/switch"
import { findHistoryItemByVersion, findHistoryItemForTime, formatDateTime } from "../lib/task-version-utils"
import { TaskVersionItem } from "./task-version-item"

export function TaskVersionPanel({ history, libraryAsOf, libraryTaskVersion, onSelectVersion, onOpenAtVersionTime }) {
    const selectedItem =
        findHistoryItemByVersion(history, libraryTaskVersion) ??
        findHistoryItemForTime(history, libraryAsOf) ??
        history?.[0]
    const selectedVersion = selectedItem?.version
    const isViewingVersion = !!libraryTaskVersion
    const statusLabel =
        isViewingVersion && selectedItem ? `Viewing ${buildSelectedSummary(selectedItem)}` : "Current component state"

    return (
        <Box
            sx={{
                width: 360,
                flexShrink: 0,
                border: (theme) => `1px solid ${theme.palette.divider}`,
                borderRadius: 1,
                bgcolor: "background.paper",
                alignSelf: "flex-start",
                position: "sticky",
                top: 24,
                maxHeight: "75vh",
                overflowY: "hidden",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Stack spacing={1} sx={{ p: 2, flexShrink: 0 }}>
                <Stack direction="row" justifyContent="space-between" alignItems="center">
                    <Typography variant="subtitle1">Versions</Typography>
                    <If value={isViewingVersion}>
                        <Button size="small" variant="text" onClick={handleBackToLive}>
                            Back to Live
                        </Button>
                    </If>
                </Stack>
                <Typography variant="caption" color="text.secondary">
                    {statusLabel}
                </Typography>
            </Stack>

            <Divider sx={{ flexShrink: 0 }} />

            <If value={history?.length}>
                <List sx={{ p: 1, overflow: "auto", flexGrow: 1 }}>
                    <Repeat
                        list={history}
                        item={
                            <TaskVersionItem
                                selectedVersion={selectedVersion}
                                onSelectVersion={onSelectVersion}
                                onOpenAtVersionTime={onOpenAtVersionTime}
                            />
                        }
                    />
                </List>
            </If>
        </Box>
    )

    function handleBackToLive() {
        onSelectVersion(null)
    }

    function buildSelectedSummary(item) {
        return `v${item.version} from ${formatDateTime(item.createdAt)}`
    }
}
